import { Dispatch, memo, SetStateAction } from 'react';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';

import { Location } from 'iconsax-react';

import { GeoLocation } from '@/shared/contexts/AddressContext';

import { Address } from '../../models/address';
import { createNewAddress } from '../../utils';
import { Label } from './styles';

interface InputSearchProps {
  inputSearchValue: string;
  placeholder: string;
  setInputSearchValue: Dispatch<SetStateAction<string>>;
  setGeoLocation: Dispatch<SetStateAction<GeoLocation>>;
  setSelectAddressToEdit: Dispatch<SetStateAction<Address | null>>;
}

const InputSearch: React.FC<InputSearchProps> = ({
  inputSearchValue,
  placeholder,
  setGeoLocation,
  setInputSearchValue,
  setSelectAddressToEdit,
}) => {
  const handleOnSelect = async (value: string) => {
    const results = await geocodeByAddress(value);
    const { address_components } = results[0];
    const selectedAddress = createNewAddress(address_components);
    const { lat: latitude, lng: longitude } = await getLatLng(results[0]);

    setInputSearchValue(value);
    setSelectAddressToEdit(selectedAddress);
    setGeoLocation({ latitude, longitude });
    setTimeout(() => {
      document.getElementById('btn-confirm-address')?.focus();
    }, 500);
  };

  return (
    <div>
      <PlacesAutocomplete
        value={inputSearchValue}
        onChange={setInputSearchValue}
        onSelect={handleOnSelect}
        highlightFirstSuggestion
        searchOptions={{
          componentRestrictions: {
            country: 'BR',
          },
        }}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps }) => (
          <Label>
            <input
              id="input-search-address"
              {...getInputProps({
                placeholder: `${placeholder}`,
                className: 'location-search-input',
                autoFocus: true,
              })}
            />
            <div className="autocomplete-dropdown-container">
              {suggestions.map(suggestion => {
                const className = suggestion.active
                  ? 'suggestion-item--active'
                  : 'suggestion-item';

                const style = suggestion.active
                  ? { cursor: 'pointer' }
                  : { cursor: 'pointer' };

                return (
                  <div key={suggestion.placeId}>
                    <div
                      {...getSuggestionItemProps(suggestion, {
                        className,
                        style,
                      })}
                    >
                      <Location variant="Bold" />
                      <div>
                        <span>{suggestion.formattedSuggestion.mainText}</span>
                        <p>{suggestion.formattedSuggestion.secondaryText}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Label>
        )}
      </PlacesAutocomplete>
    </div>
  );
};

export const InputSearchAddress = memo(InputSearch);
